module.exports = __webpack_public_path__ + "static/media/2.cd105d09.JPG";